// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__2KY2A","head":"ProcedureTableInfo_head__Ef7xp"};